import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const HEY_PONGO_INTEGRATION_NAME = 'hey-pongo';
/** Merchant's Hey Pongo login, used with JUST's client_id/secret in the password grant. */
export const ZHeyPongoCredentials = z.object({
    email: z.string().min(1),
    password: z.string().min(1),
});
/** The Hey Pongo store this shop maps to. `id` is the `sto_…` id; `slug` the legacy slug. */
export const ZHeyPongoStore = z.object({
    slug: z.string().min(1),
    id: z.string().min(1),
});
export const ZHeyPongoSettings = z.object({
    showPointsEstimation: z.boolean().optional(),
    allowPointsRedemption: z.boolean().optional(),
    store: ZHeyPongoStore.optional(),
});
export const ZHeyPongoExternalData = z.object({
    campaigns: z
        .array(z.object({
        id: z.number(),
        name: z.string(),
        earningRatio: z.number().optional(),
        unrenderedDetails: z.string().optional(),
    }))
        .optional(),
    stores: z
        .array(z.object({ id: z.string(), slug: z.string(), name: z.string().optional() }))
        .optional(),
    redemptionOptions: z
        .array(z.object({
        id: z.union([z.string(), z.number()]),
        name: z.string(),
        pointsCost: z.number(),
        discountAmount: z.number().optional(),
        discountPercentage: z.number().optional(),
        discountType: z.string().optional(),
        discountRateCents: z.number().optional(),
        currency: z.string().optional(),
        variantId: z.string().optional(),
        cartMinimum: z.number().optional(),
        description: z.string().optional(),
    }))
        .optional(),
    lastSyncedAt: z.iso.datetime().optional(),
});
export const ZHeyPongoIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(HEY_PONGO_INTEGRATION_NAME),
    category: z.literal('loyalty'),
    credentials: ZHeyPongoCredentials,
    settings: ZHeyPongoSettings,
    externalData: ZHeyPongoExternalData.optional(),
}).shape);
//# sourceMappingURL=hey-pongo.js.map